import { IConfig } from '@cian/config/shared';

export const isTopTabsRedesignedEnabled = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('frontend-chats.showTopTabs.Enabled'));
};
